<div class="fixActionRow">
  <div mat-dialog-title>
    ตั้งค่าข้อความขั้นตอนการรับบริการ
  </div>
  <mat-dialog-content class="mat-typography">
    กรุณาระบุขั้นตอนการรับบริการ บรรทัดละ 1 ข้อ โดยไม่ต้องมีตัวเลขนำหน้า
    <br>
    <mat-form-field appearance="fill">
      <mat-label>ขั้นตอนการรับบริการ</mat-label>
      <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="8" [(ngModel)]="instructions"></textarea>
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-raised-button mat-dialog-close>ยกเลิก</button>
    <button mat-raised-button class="submit-button" (click)="saveInstructions()">บันทึก</button>
  </mat-dialog-actions>
</div>
